import { signedApiClient } from './apiClient';

class MetricsService {

  async recordEntryMetrics(payload: {
    entryId: string;
    sessionId: string;
    studyId: string;
    formId: string;
    event: string;
    timestamp: number;
  }) {
    const uri = `metrics`;
    const apiClient = signedApiClient('POST', uri);
    return await apiClient.post(uri, payload);
  }

  recordEntryMetricsWithKeepAlive(payload: {
    entryId: string;
    sessionId: string;
    studyId: string;
    formId: string;
    event: string;
    timestamp: number;
  }) {
    const uri = `metrics`;
    const apiClient = signedApiClient('POST', uri);
    const url = apiClient.defaults.baseURL + '/' + uri;
    
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };

    if (apiClient.defaults.headers.common['X-Date']) {
      headers['X-Date'] = apiClient.defaults.headers.common['X-Date'] as string;
    }
    if (apiClient.defaults.headers.common['Authorization']) {
      headers['Authorization'] = apiClient.defaults.headers.common['Authorization'] as string;
    }

    fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(() => {});
  }
}

export default new MetricsService();

